import { format } from 'date-fns';

export const printReceipt = (sale, printProfile, size) => {
  const is58 = size === '58';
  const maxChar = is58 ? 32 : 48;
  const pageWidth = is58 ? '58mm' : '80mm';
  const fontSize = is58 ? '10px' : '12px';
  const padding = is58 ? '4mm' : '6mm';

  const formatNum = (num) => {
    return new Intl.NumberFormat('id-ID').format(num || 0);
  };

  const now = new Date(sale.createdAt);
  const dateStr = format(now, 'dd/MM/yyyy');
  const timeStr = format(now, 'HH:mm:ss');

  const p = printProfile || {};

  // Build receipt HTML
  const receiptHtml = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Print Struk</title>
      <style>
        @page { width: ${pageWidth}; margin: 0; padding: 0; }
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          width: ${pageWidth};
          font-family: 'Courier New', 'Lucida Console', monospace;
          font-size: ${fontSize};
          line-height: 1.4;
          padding: ${padding};
          color: #000;
        }
        .receipt { width: 100%; }
        .center { text-align: center; }
        .bold { font-weight: bold; }
        .header-text { font-size: ${is58 ? '11px' : '13px'}; }
        .line { border-top: 1px dashed #000; margin: 4px 0; }
        .total-row { display: flex; justify-content: space-between; font-weight: bold; font-size: ${is58 ? '12px' : '14px'}; }
        .footer-text { font-size: ${is58 ? '9px' : '11px'}; }
        @media print { body { margin: 0; padding: ${padding}; } }
      </style>
    </head>
    <body>
      <div class="receipt">
        ${p.header1 ? `<div class="center bold header-text">${p.header1}</div>` : ''}
        ${p.header2 ? `<div class="center" style="font-size:${is58 ? '9px' : '11px'}">${p.header2}</div>` : ''}
        ${p.header3 ? `<div class="center" style="font-size:${is58 ? '9px' : '11px'}">${p.header3}</div>` : ''}
        ${(p.header1 || p.header2 || p.header3) ? '<div class="line"></div>' : ''}

        <div class="center bold">STRUK PENJUALAN</div>
        <div class="line"></div>

        <div>No: ${sale.nomorNota}</div>
        <div>Tgl: ${dateStr} ${timeStr}</div>
        <div>Kasir: ${sale.createdBy?.name || '-'}</div>
        <div class="line"></div>

        ${sale.items.map(item => {
          const nama = item.product?.nama || 'Item';
          const qty = item.quantity;
          const harga = item.subtotalDiskon || item.subtotal;
          const hasDiskon = item.diskonTipe && item.diskon > 0;
          const diskonLabel = hasDiskon 
            ? `  (disc ${item.diskonTipe === 'PERSEN' ? item.diskon + '%' : 'Rp' + formatNum(item.diskon)})`
            : '';
          return `
            <div style="display:flex;justify-content:space-between">
              <span>${nama}</span>
              <span>${' '.repeat(Math.max(1, maxChar - nama.length - 6 - String(harga).length))}${qty}x ${formatNum(harga)}</span>
            </div>
            ${hasDiskon ? `<div style="font-size:${is58 ? '8px' : '9px'};color:#666">${diskonLabel}</div>` : ''}
          `;
        }).join('')}
        <div class="line"></div>

        ${sale.totalDiskonItem > 0 ? `<div style="display:flex;justify-content:space-between"><span>Diskon Item</span><span>-${formatNum(sale.totalDiskonItem)}</span></div>` : ''}
        ${sale.diskonTotalRp > 0 ? `<div style="display:flex;justify-content:space-between"><span>Diskon Total${sale.diskonTotalTipe === 'PERSEN' ? ' ('+sale.diskonTotal+'%)' : ''}</span><span>-${formatNum(sale.diskonTotalRp)}</span></div>` : ''}

        <div class="total-row">
          <span>TOTAL</span>
          <span>Rp ${formatNum(sale.totalHarga)}</span>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:${is58 ? '9px' : '11px'}">
          <span>Bayar</span><span>Rp ${formatNum(sale.bayar)}</span>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:${is58 ? '9px' : '11px'}">
          <span>Kembali</span><span>Rp ${formatNum(sale.kembalian)}</span>
        </div>
        <div style="font-size:${is58 ? '9px' : '11px'};text-align:right">${sale.metodePembayaran}</div>

        <div class="line"></div>

        ${p.footer1 ? `<div class="center footer-text">${p.footer1}</div>` : ''}
        ${p.footer2 ? `<div class="center footer-text">${p.footer2}</div>` : ''}
        ${p.footer3 ? `<div class="center footer-text">${p.footer3}</div>` : ''}

        <div style="text-align:center;font-size:${is58 ? '8px' : '9px'};margin-top:4px;color:#999">
          Dicetak: ${format(new Date(), 'dd/MM/yyyy HH:mm')}
        </div>
      </div>
    </body>
    </html>
  `;

  const printWindow = window.open('', '_blank', 'width=400,height=600');
  if (printWindow) {
    printWindow.document.write(receiptHtml);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); }, 300);
  }
};
